import React from 'react'
import { Link } from 'react-router-dom'
import EditorMultipleChoice from '../../../../../../component/common/EditorMultipleChoice'
import Header from '../../../../../../component/common/layout/Header'
import LanguageSubHeader from '../../../../../../component/common/layout/LanguageSubHeader'
import SurveyListHeader from '../../../../../../component/common/layout/SurveyListHeader'
import SurveyListSidebar from '../../../../../../component/common/layout/SurveyListSidebar'
import Svg from '../../../../../../component/common/Svg'
import Card from '../../../../../../core/Card';
import style from "../../../../../style.module.css";
import Buttons from './Buttons'
import LandingPage from './LandingPage'
import LeadGen from './LeadGen'
import Questions from './Questions'
import Report from './Report'
import ThankyouPage from './ThankyouPage'

export default function Index() {
    return (
        <>
            <div className='d-flex flex-column main-outer-wrapper main-site-wrapper bg-white'>
                <SurveyListHeader />
                <div id="viewport" className="d-flex bg-white">
                    <SurveyListSidebar />
                    <div className="flex-grow-1">
                        <LanguageSubHeader />
                        <div className="page-content-wrap">
                            <div className="page-heading d-flex justify-content-between align-items-center">
                                <div className='heading'>
                                    {/* breadcrumbs here */}
                                    <nav aria-label="breadcrumb">
                                        <ol className="breadcrumb">
                                            <li className="breadcrumb-item">
                                            <Link to="/admin/survey/list">Survey</Link>
                                        </li><li className="breadcrumb-item"><a href="#">Survey Name</a></li>
                                            <li className="breadcrumb-item active" aria-current="page"><strong>Translation</strong></li>
                                        </ol>
                                    </nav>
                                    {/* breadcrumbs ends here */}
                                    <h1>Translation</h1>
                                </div>
                                <div className="flex-grow-1 ps-3 translate-button-wrap d-flex align-items-center justify-content-end">
                                    <div className="Sortingcheck me-4 d-flex align-items-center">
                                        <input type="checkbox" className="form-check-input" id="selectAll-check" />
                                        <label className="form-check-label" htmlFor="selectAll-check">Select All</label>
                                    </div>
                                    <button type="button" className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#deleteModal"><Svg name="google-translate" /> Translate</button>
                                </div>
                            </div>
                            <div className="translation-wrapper">
                                <Report />
                                <ul className="nav nav-tabs" id="myTab" role="tablist">
                                    <li className="nav-item" role="presentation">
                                        <button className="nav-link active" id="questions-tab" data-bs-toggle="tab" data-bs-target="#questions" type="button" role="tab" aria-controls="questions" aria-selected="false">Questions</button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button className="nav-link" id="lead-gen-tab" data-bs-toggle="tab" data-bs-target="#lead-gen" type="button" role="tab" aria-controls="lead-gen" aria-selected="true">Lead-gen</button>
                                    </li>
                                    {/* <li className="nav-item" role="presentation">
                                        <button className="nav-link" id="report-tab" data-bs-toggle="tab" data-bs-target="#report" type="button" role="tab" aria-controls="report" aria-selected="false">Report</button>
                                    </li> */}
                                    <li className="nav-item" role="presentation">
                                        <button className="nav-link" id="landing-page-tab" data-bs-toggle="tab" data-bs-target="#landing-page" type="button" role="tab" aria-controls="landing-page" aria-selected="false">Landing page</button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button className="nav-link" id="thankyou-page-tab" data-bs-toggle="tab" data-bs-target="#thankyou-page" type="button" role="tab" aria-controls="thankyou-page" aria-selected="false">Thankyou page</button>
                                    </li>

                                    <li className="nav-item" role="presentation">
                                        <button className="nav-link" id="buttons-tab" data-bs-toggle="tab" data-bs-target="#buttons" type="button" role="tab" aria-controls="buttons" aria-selected="false">Buttons</button>
                                    </li>
                                </ul>

                                <div className="tab-content" id="myTabContent">
                                    <div className="tab-pane fade show active" id="questions" role="tabpanel" aria-labelledby="questions-tab">
                                        <Questions />
                                    </div>
                                    <div className="tab-pane fade" id="lead-gen" role="tabpanel" aria-labelledby="lead-gen-tab">
                                        <LeadGen />
                                    </div>


                                    <div className="tab-pane fade" id="landing-page" role="tabpanel" aria-labelledby="landing-page-tab">
                                        <LandingPage />
                                    </div>

                                    <div className="tab-pane fade" id="report" role="tabpanel" aria-labelledby="report-tab">
                                        <Report />
                                    </div>

                                    <div className="tab-pane fade" id="buttons" role="tabpanel" aria-labelledby="buttons-tab">
                                        <Buttons />
                                    </div>

                                    <div className="tab-pane fade" id="thankyou-page" role="tabpanel" aria-labelledby="thankyou-page-tab">
                                        <ThankyouPage />
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>



            <div className="customvar-modal modal custom-modal fade deleteModal translateAllModal" id="deleteModal" tabIndex={-1} aria-labelledby="deleteModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className={"formcontainer" + " " + style.container}>
                                <div className={"formvawrapper delete-modal-wrap modal-setting-medium" + " " + style.wrapper}>
                                    <Card view="raised" className={"formstyle p-0" + " " + style.card} >

                                        <div className="delete-body-wrap delete-language">
                                            <div className="heading">
                                                <h3>Are you sure you want to translate all selected option?</h3>
                                            </div>
                                            <div className="warning-message">
                                                <div className="title d-flex align-items-center">
                                                    <svg width={40} height={42} viewBox="0 0 40 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M20 2L37.3205 32H2.67949L20 2Z" stroke="#F05454" strokeWidth={3} strokeLinejoin="round" />
                                                        <path d="M20 13.5385V22" stroke="#F05454" strokeWidth={3} />
                                                        <circle cx="19.9994" cy="25.8461" r={1} fill="black" stroke="#F05454" strokeWidth="1.07692" />
                                                    </svg>
                                                    <h4>Warning</h4>
                                                </div>
                                                <p>The translation will overwrite any previous data.</p>
                                            </div>

                                            <div className="button-wrap d-flex justify-content-end">
                                                <button type="button" className="btn btn-bordered color-cancel" data-bs-dismiss="modal">Cancel</button>
                                                <button type="button" className="btn btn-delete ms-3">Translate</button>
                                            </div>
                                        </div>
                                    </Card>
                                </div >

                            </div >
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}
